import React, { useState, useEffect } from 'react'
import Button from './ui/Button';
import { Auth, Hub } from 'aws-amplify'
import Container from './ui/Container'
import AuthForm from './AuthForm/AuthForm'
import {Link} from 'react-router-dom';
import BackgroundImage from './ui/BackgroundImage';
import Flex from './ui/Flex';

function Profile() {
  useEffect(() => {
    checkUser()
    Hub.listen('auth', (data) => {
      const { payload } = data
      if (payload.event === 'signOut') {
        setUser(null)
      }
    })
  }, [])

  const [user, setUser] = useState(null)

  async function checkUser() {
    try {
      const data = await Auth.currentUserPoolUser()
      const userInfo = { username: data.username, ...data.attributes }
      setUser(userInfo)
    } catch (err) { console.log('error: ', err) }
  }

  function signOut() {
    Auth.signOut()
      .catch(err => console.log('error signing out: ', err))
  }

  if (user) {
    return (
      <Container>
        <h1>Profile</h1>
        <h2>Username: {user.username}</h2>
        <h3>Email: {user.email}</h3>
        <h4>Phone: {user.phone_number}</h4>
        <Link to='/clients'>Clients</Link>
        <Button onClick={signOut}>Sign Out</Button>
      </Container>
    );
  }
  return (
    <BackgroundImage>
      <Flex justifyContent='center'>
      <div style={{marginTop: '100px', padding: '10px', width: 'fit-content', backgroundColor: "rgba(0, 0, 0, 0.5)"}}>
        <AuthForm setUser={setUser} />
      </div>
      </Flex>
    </BackgroundImage>
  )
}

export default Profile
